import React, {Dispatch, useEffect, useRef, useState} from 'react';
import {
    Formik,
    Form,
    Field,
} from 'formik';
import "./ContactPopup.scss"
import {CalculatedRainWater, Marker} from "../App";
import * as Yup from 'yup';
import generateReportLink from "./generateReportLink";

const DataFormSchema = Yup.object().shape({
    email: Yup.string().email('Podaj prawidłowy adres email').required('Pole jest wymagane'),
    phoneNumber: Yup.string().required('Pole jest wymagane'),
    message: Yup.string().required('Pole jest wymagane')
});


export interface DataFormValues {
    reportLink: string,
    email: string;
    phoneNumber: string;
    message: string;
}


type Props = {
    setShowContact: Dispatch<boolean>,
    calculatedRainWater: CalculatedRainWater,
    marker: Marker,
    link: string,
    setLink: Dispatch<string>,
    reportHash: string,
    setReportHash: Dispatch<string>,
}

type Response = {
    error?: string,
    message?: string,
}


const reqHost = window.location.host == 'localhost:3000' ? 'http://localhost:8000/' : '/';

function ContactPopup({ setShowContact, calculatedRainWater, marker, link, setLink, reportHash, setReportHash }: Props) {
    const [loading, setLoading] = useState<boolean>(true);
    const [sendResponse, setSendResponse] = useState<Response|null>(null);

    console.log("link:", link);

    useEffect(() => {
        getReportLink();
    }, [])

    const getReportLink = async () => {
        if (link !== "" && reportHash !== "") {
            setLoading(false);
            return;
        }

        const data = await generateReportLink(calculatedRainWater, marker);
        if (data) {
            setLink(data.link);
            setReportHash(data.hash);
            setLoading(false);
        }
    }

    const sendContact = async (email: string, reportLink: string, phoneNumber: string, message: string, hash: string) => {
        setLoading(true);

        const res: Response = await fetch(
            reqHost + "wp-json/rainwatercalculator/report/contact",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    reportLink,
                    phoneNumber,
                    message,
                    hash
                })
            }
        ).then((response) => response.json());

        setLoading(false);
        setSendResponse(res);
    }

        console.log("render:", link);
    return (
        <div className="ContactPopup popup">
            <div className="container">
                <div className='row'>
                    <div className='header ms-2 mt-3'>
                        <span><h3>Zapytaj o ofertę lub zadaj pytanie odnośnie wygenerowanego raportu</h3></span>
                        <button type="button" className="btn-close" onClick={() => {
                            setShowContact(false)
                        }}></button>
                    </div>
                    {
                        sendResponse && <div className='row'>
                            <div className="m-3">
                                <div className="col-md-12">
                                    {sendResponse.error &&
                                        <div className='send-error'>{sendResponse.error}</div>}
                                    {sendResponse.message &&
                                        <div className='send-success'>{sendResponse.message}</div>}
                                </div>
                                <div className="col-md-12 mt-4 d-flex justify-content-end">
                                    <a className='yellow-button' onClick={() => {
                                        setShowContact(false)
                                    }}>Zamknij</a>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        loading && <div className='loading-container '>
                            <div className="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    }
                </div>
                {!sendResponse && !loading && link && <Formik
                        initialValues={{
                            reportLink: link,
                            email: '',
                            phoneNumber: '',
                            message: '',
                        }}
                        validationSchema={DataFormSchema}
                        onSubmit={(values, actions) => {
                            console.log(values);
                            // actions.setSubmitting(false);
                            sendContact(values.email, values.reportLink, values.phoneNumber, values.message, reportHash)
                        }}
                    >
                        {({ values, errors, touched , submitForm}) => (
                            <Form>
                            <div className='row' style={{width: "100%"}}>
                                <div className="m-3">
                                    <div className="col-md-12">
                                        <Field
                                            as="textarea"
                                            name="message"
                                            rows="7"
                                            className="form-control"
                                            placeholder="Tu wpisz dodatkowe pytania, jakie chcesz zadać naszemu doradcy odnośnie produktów lub danych w raporcie. Odpowiemy najpóźniej w następnym dniu roboczym"
                                        />
                                        {touched.message && errors.message && (
                                            <span className='error-text'>{errors.message}</span>
                                        )}
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="inputReportLink">Link do Twojego raportu przekazywany do
                                            doradcy</label>
                                        <Field
                                            type="text"
                                            name="reportLink"
                                            className="form-control"
                                            id="inputReportLink"
                                            readOnly
                                        />
                                    </div>

                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="email">Adres email <span
                                            className='error-text'>*</span></label>
                                        <Field
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            id="email"
                                        />
                                        {touched.email && errors.email && (
                                            <span className='error-text'>{errors.email}</span>
                                        )}
                                    </div>

                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="phoneNumber">Numer telefonu <span
                                            className='error-text'>*</span></label>
                                        <Field
                                            type="string"
                                            name="phoneNumber"
                                            className="form-control"
                                            id="phoneNumber"
                                        />
                                        {touched.phoneNumber && errors.phoneNumber && (
                                            <span className='error-text'>{errors.phoneNumber}</span>
                                        )}
                                    </div>

                                    <div className="col-md-12 mt-4 d-flex justify-content-center">
                                        <a className='yellow-button' onClick={submitForm}>Wyślij
                                            zapytanie</a>
                                    </div>
                                </div>
                            </div>
                        </Form>
                            )}
                    </Formik>}
            </div>
            <div className="background"/>
        </div>
    );
}

export default ContactPopup;
